import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import AudioPlayer from "../../QuestionPage/AudioPlayer";
import HighlightWords from "../../QuestionPage/HighlightWord";

export default function HighlightIncorrectWordMockPage({
  question,
  onInputChange,
  questionNumber,
  maxQuestion,
}) {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  const [Options, setOptions] = useState([]);
  const [originalWords, setOriginalWords] = useState("");
  const [Title, setTitle] = useState("");
  const [Mcq_Question, setMcq_Question] = useState("");
  const [McqOptions, setMcqOptions] = useState("");
  const [selectedWords, setSelectedWords] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [audioLink, setAudioLink] = useState("");
  const audioRef = useRef(null);

  useEffect(() => {
    setAudioLink(question.media_link);
    setOriginalWords(question.answer);
    setMcqOptions(question.option);
    setMcq_Question(question.question_mcq);
    resetAudio();
  }, [question]);

  const resetAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  const handleWordClick = (index, isCorrect) => {
    if (submitted) return; // Prevent selection after submission

    const word = originalWords.split(" ")[index]; // Get the word at the specific index

    // Regex to remove all HTML tags and specific unwanted patterns
    const cleanWord = word.replace(/<\/?[^>]+(>|$)|id='cAns'>/g, "");

    let updatedSelectedWords;

    if (selectedWords.some((item) => item.index === index)) {
      updatedSelectedWords = selectedWords.filter(
        (item) => item.index !== index
      );
    } else {
      updatedSelectedWords = [
        ...selectedWords,
        { index, word: cleanWord, isCorrect },
      ];
    }

    setSelectedWords(updatedSelectedWords);
    onInputChange(updatedSelectedWords); // Pass the updated array to the parent component
  };

  console.log("Original Word:", originalWords);

  return (
    <div>
      <div className="min-h-[calc(100vh-230px)] overflow-hidden rounded-md border border-slate-200 bg-white p-4 shadow-sm sm:p-6 lg:p-8">
        <div className="h-1.5 rounded-full bg-violet-600"></div>
        <h3 className="text-lg pt-3 font-bold text-gray-900 sm:text-2xl ml-1 text-center md:text-start">
          Mock Test
        </h3>
        <h2 className="hidden">
        </h2>
        <h2 className="mt-3 inline-flex rounded-md bg-violet-50 px-3 py-2 text-sm font-bold text-violet-800 ring-1 ring-violet-100">
          {" "}
          Question {questionNumber} of {maxQuestion}
        </h2>
        <p className="mt-4 max-w-5xl text-sm leading-6 text-gray-600 sm:text-base">
          Listen to the recording and identify the words in the transcript that differ from what you hear.
        </p>
        {audioLink && <AudioPlayer audioSrc={audioLink} audioRef={audioRef} />}

        <div className="mt-4 inline-flex rounded-md bg-violet-50 px-3 py-2 text-sm font-bold text-violet-800 ring-1 ring-violet-100"></div>
        <HighlightWords
          sentence={originalWords}
          selectedWords={selectedWords}
          handleWordClick={handleWordClick}
          submitted={submitted}
        />
      </div>
    </div>
  );
}


